import React from 'react'
import Modal from 'react-modal'
import $ from 'jquery'

import GeneralPanel from './Panels/General/General'
import WebPanel from './Panels/Web/Web'
import CatAttribPanel from './Panels/CatAttrib/CatAttrib'
import ImagePanel from './Panels/Image/Image'

import './ProductView.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const ProductViewMain = (
    {
        productName,
        selectPanel,
        isOpen,
        onAfterOpen,
        onRequestClose
    }) => (
        <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
            <div className="productView editpages">
                <h1>{productName}</h1>

                <select onChange={selectPanel}>
                    <option panel="General">General</option>
                    <option panel="Category" value="Category">Category-Attributes</option>
                    <option panel="Web">Web</option>
                    <option panel="Image">Image</option>
                </select>

                <br />

                <ul className="productview">
                    <li className="productview" panel="General" onClick={selectPanel}>General</li>
                    <li className="productview" panel="Stock" disabled>Stock Management</li>
                    <li className="productview" panel="Pricing" disabled>Pricing</li>
                    <li className="productview" panel="Warehouse" disabled>Warehouse</li>
                    <li className="productview" panel="Category" onClick={selectPanel}>Category-Attributes</li>
                    <li className="productview" panel="Web" onClick={selectPanel}>Web</li>
                    <li className="productview" panel="Image" onClick={selectPanel}>Image</li>
                    <li className="productview" panel="History" disabled>History</li>
                </ul>

                <i className="fa fa-arrow-circle-left" onClick={onRequestClose}><span>Back</span></i>

                <div className="panelFrame" id="General"><GeneralPanel /></div>
                <div className="panelFrame" id="Stock"><p className="panelFrame">Stock Management Panel TBD</p></div>
                <div className="panelFrame" id="Pricing"><p className="panelFrame">Pricing Panel TBD</p></div>
                <div className="panelFrame" id="Warehouse"><p className="panelFrame">Warehouse Panel TBD</p></div>
                <div className="panelFrame" id="Category"><CatAttribPanel /></div>
                <div className="panelFrame" id="Web"><WebPanel /></div>
                <div className="panelFrame" id="Image"><ImagePanel /></div>
                <div className="panelFrame" id="History"><p className="panelFrame">History Panel TBD</p></div>
            </div>
        </Modal>
    );

// Modal.setAppElement('body');

export default ProductViewMain